import { getCookie } from "@washingtonpost/front-end-utils";

function b64DecodeUnicode(str) {
  return decodeURIComponent(
    atob(str).replace(/(.)/g, (m, p) => {
      let code = p.charCodeAt(0).toString(16).toUpperCase();
      if (code.length < 2) {
        code = "0" + code;
      }
      return "%" + code;
    })
  );
}

function base64UrlDecode(str) {
  let output = str.replace(/-/g, "+").replace(/_/g, "/");
  switch (output.length % 4) {
    case 0:
      break;
    case 2:
      output += "==";
      break;
    case 3:
      output += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }

  try {
    return b64DecodeUnicode(output);
  } catch {
    return atob(output);
  }
}

function jwtDecode(token) {
  const part = token.split(".")[1];
  let decoded;
  try {
    decoded = base64UrlDecode(part);
    return JSON.parse(decoded);
  } catch (e) {
    throw new Error(`Invalid token specified`);
  }
}

const checkJwt = jwt => {
  if (!jwt) return false;
  try {
    // 1. Decode the token (returns the payload directly)
    const decoded = jwtDecode(jwt);

    let adFree = false;

    // 2. Access the 'fs' claim directly from the decoded object
    const fsClaim = decoded["fs"];

    /* 3. Ensure it's a string before calling .split() to prevent crashes
      Note: format will look like 1|1 for the first feature if the user has ad-free status on (we ignore anything before the pipe).
        as we add features it will look like 1|10101 with 1 indicating true and 0 indicating false for each feature
    */
    if (
      typeof fsClaim === "string" &&
      fsClaim.split("|")[1]?.charAt(0) === "1"
    ) {
      adFree = true;
    }

    return adFree;
  } catch (error) {
    // returns false if the token is invalid or cannot be decoded, rather than throwing an error
    return false;
  }
};

export function isAdFree() {
  const wapoActmgmtCookie = getCookie("wapo_actmgmt");
  const jwtCookie = getCookie("wp_f_token");
  if (!wapoActmgmtCookie?.length && !jwtCookie?.length) {
    return false; // No cookie means not an ad-free user
  }
  // Check if the JWT indicates ad-free status
  const isJwtAdFree = checkJwt(jwtCookie);
  // Check if a user is in the EU and should not see ads
  const isEUAdFree = /(\b|.*\|)EU_NOADS:1([^;]*)/.test(wapoActmgmtCookie);
  // Check if a user is in the US and also should not see ads
  const isUSAdFree = /(\b|.*\|)NOADS:1([^;]*)/.test(wapoActmgmtCookie);

  return isJwtAdFree || isUSAdFree || isEUAdFree;
}
